import { FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DoctorRow } from './DoctorRow';
import { toIsoDate } from '../../util/DateFormat';

export default function AllDoctors() {
  const [doctors, setDoctors] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [filteredHospital, setFilteredHospital] = useState('');
  const [filteredDateFrom, setFilteredDateFrom] = useState('');
  const [filteredDateTo, setFilteredDateTo] = useState('');

  useEffect(() => {
    axios('/reports/doctors').then((data) => {
      setDoctors(data.data);
      setHospitals(data.data.map((doctor) => doctor.hospital).filter((v, i, a) => a.indexOf(v) === i)); //filter unique
    });
  }, []);

  const filterDoctors = (hospital, fromDate, toDate) => {
    fromDate = toIsoDate(fromDate);
    toDate = toIsoDate(toDate);
    axios('/reports/doctors?hospital=' + hospital + '&fromDate=' + fromDate + '&toDate=' + toDate).then((data) => setDoctors(data.data));
  };

  return (
    <>
      <Paper
        sx={{
          maxWidth: '90%',
          marginTop: 16,
          marginBottom: 16,
          margin: 'auto',
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography
              sx={{
                width: '100%',
                textAlign: 'center',
                marginTop: '16px',
                fontSize: '2em',
              }}
            >
              Doctors Activity Report
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <hr></hr>
          </Grid>
          <Grid item xs={4}>
            <FormControl
              sx={{
                display: 'flex',
                width: '90%',
                margin: 'auto',
                marginTop: '32px',
                marginBottom: '32px',
                textAlign: 'center',
              }}
            >
              <InputLabel id="hospital_label">Hospital</InputLabel>
              <Select
                input={<OutlinedInput label="Hospital" />}
                labelId="hospital_label"
                value={filteredHospital}
                onChange={(event) => {
                  setFilteredHospital(event.target.value);
                  filterDoctors(event.target.value, filteredDateFrom, filteredDateTo);
                }}
              >
                <MenuItem value={''}>All</MenuItem>
                {hospitals.map((hospital) => (
                  <MenuItem key={hospital} value={hospital}>
                    {hospital}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl
              sx={{
                display: 'flex',
                width: '90%',
                margin: 'auto',
                marginTop: '32px',
                marginBottom: '32px',
                textAlign: 'center',
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="From date"
                  inputFormat="yyyy-MM-dd"
                  mask="____-__-__"
                  onChangeRaw={(e) => e.preventDefault()}
                  value={filteredDateFrom}
                  onChange={(newValue) => {
                    // eslint-disable-next-line
                    if (newValue != 'Invalid Date') {
                      setFilteredDateFrom(newValue);
                      filterDoctors(filteredHospital, newValue, filteredDateTo);
                    }
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl
              sx={{
                display: 'flex',
                width: '90%',
                margin: 'auto',
                marginTop: '32px',
                marginBottom: '32px',
                textAlign: 'center',
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  label="To date"
                  inputFormat="yyyy-MM-dd"
                  mask="____-__-__"
                  onChangeRaw={(e) => e.preventDefault()}
                  value={filteredDateTo}
                  onChange={(newValue) => {
                    // eslint-disable-next-line
                    if (newValue != 'Invalid Date') {
                      setFilteredDateTo(newValue);
                      filterDoctors(filteredHospital, filteredDateFrom, newValue);
                    }
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <hr></hr>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table
            sx={{
              minWidth: 650,
            }}
            aria-label="simple table"
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Hospital</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Total Patients</TableCell>
                <TableCell>Total Tests</TableCell>
                <TableCell>Valid Face</TableCell>
                <TableCell>Valid Speech</TableCell>
                <TableCell>Valid Arms</TableCell>
                <TableCell>Verified Neurological Examination</TableCell>
                <TableCell>For Review</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {doctors
                .sort((d1, d2) => d2.tests - d1.tests)
                .map((doctor) => (
                  <DoctorRow doctor={doctor} key={doctor.email} fromDate={toIsoDate(filteredDateFrom)} toDate={toIsoDate(filteredDateTo)} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}
